import {useState} from "react";
import ReactApexChart from "react-apexcharts";
import {Dropdown} from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DateModal from "./dateModal";

const InterventionStats = ({
  stats,
  optionsList,
  dateLabel,
  setDateLabel,
  dispatch,
  filter,
}) => {
  // const options = ["Cette semaine", "Ce mois", "Cette année"];
  const [option, setOption] = useState(optionsList[0]);
  const [openModal, setOpenModal] = useState(false);
  const safeStats = stats ?? {};
  const total = Number.isFinite(Number(safeStats?.total))
    ? Number(safeStats.total)
    : 0;
  const safeSeries = [
    Number.isFinite(Number(safeStats?.perStatus?.PROCESSING))
      ? Number(safeStats.perStatus.PROCESSING)
      : 0,
    Number.isFinite(Number(safeStats?.perStatus?.REPORTED))
      ? Number(safeStats.perStatus.REPORTED)
      : 0,
    Number.isFinite(Number(safeStats?.perStatus?.ENDED))
      ? Number(safeStats.perStatus.ENDED)
      : 0,
    Number.isFinite(Number(safeStats?.perStatus?.CANCELED))
      ? Number(safeStats.perStatus.CANCELED)
      : 0,
    Number.isFinite(Number(safeStats?.perStatus?.NEW))
      ? Number(safeStats.perStatus.NEW)
      : 0,
  ];

  const data = {
    series: safeSeries,
    options: {
      chart: {
        // width: 270,
        type: "polarArea",
        sparkline: {
          enabled: true,
        },
      },

      labels: ["En cours", "Reportées", "Réalisées", "Annulées", "Nouvelles"],
      fill: {
        opacity: 1,
        colors: ["#FF6600", "#1A64B9", "#707070", "#EAEAEA", "#FFCC00"],
      },
      stroke: {
        width: 0,
        colors: undefined,
      },
      yaxis: {
        show: false,
      },
      legend: {
        position: "bottom",
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 0,
          },
          spokes: {
            strokeWidth: 0,
          },
        },
      },
      tooltip: {
        theme: "dark",
        custom: function ({series, seriesIndex, dataPointIndex, w}) {
          const percentage =
            total > 0 ? (series[seriesIndex] * 100) / total : 0;
          return `<div style="background-color: #F1F2F7; color: #19295C; padding: 5px 10px; border-radius: 5px;">
              ${w.globals.labels[seriesIndex]}: ${Number(percentage).toFixed(0)}%
            </div>`;
        },
      },

      theme: {
        monochrome: {
          enabled: true,
          shadeTo: "light",
          shadeIntensity: 0,
        },
      },
    },
  };

  return (
    <div className="w-full col-span-2 lg:col-span-1 !rounded-xl p-6 bg-white flex flex-col gap-3 justify-start items-start">
      <DateModal
        dispatch={dispatch}
        open={openModal}
        setOpen={setOpenModal}
        type={"intervention"}
        initialDate={filter?.interventionDate}
      />
      <div className="w-full justify-between flex items-center">
        <span className="text-[#19295C] text-lg font-bold">Interventions</span>
        <Dropdown>
          <DropdownToggle
            variant=""
            className=" flex gap-2 items-center !p-0 font-medium !text-xs "
          >
            <span className="mr-2">{dateLabel}</span>
          </DropdownToggle>
          <DropdownMenu>
            {optionsList?.map((op, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  setDateLabel(op.label);
                  op.onClick("Nombre d'interventions");
                }}
                className="!text-sm"
              >
                {op.label}
              </Dropdown.Item>
            ))}
            <Dropdown.Item
              onClick={() => {
                setOpenModal(true);
                setDateLabel("Choisir la date");
              }}
              className="!text-sm"
            >
              Choisir la date
            </Dropdown.Item>
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="w-full flex items-center justify-between gap-2">
        <div className="flex flex-col justify-start gap-4">
          {data?.options?.labels.map((el, index) => (
            <div className="flex items-center justify-start gap-2" key={index}>
              <div
                style={{
                  backgroundColor: data?.options?.fill?.colors[index],
                }}
                className={`w-5 aspect-square rounded-full  `}
              ></div>
              <div className="flex flex-col items-start justify-center text-[13px] font-medium text-[#19295C] ">
                <span className="">{el}</span>
                <span className="text-[#7E7E7E]">{data?.series[index]}</span>
              </div>
            </div>
          ))}
        </div>
        <div>
          <ReactApexChart
            options={data.options}
            series={data.series}
            type="polarArea"
            height="270px"
          />
        </div>
      </div>
    </div>
  );
};

export default InterventionStats;
